export const instructions =
  'To modify a segment, press space or enter when focused on any drag handle at the end of each segment. While dragging, use the arrow keys to move the item in any given direction. Press space or enter again to set the segment end in its new position, or press escape to cancel.';
